const getSiteFooter = (rootState) =>
  rootState.ws.integration.settings.branding &&
  rootState.ws.integration.settings.branding.siteFooter;

export default getSiteFooter;
